function getFutureWeekDates() {
    const result = [];
    const today = new Date();

    for (let i = 0; i < 7; i++) {
        const date = new Date(today);
        date.setDate(today.getDate() + i);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始
        const day = String(date.getDate()).padStart(2, '0');

        result.push(`${year}-${month}-${day}`);
    }

    return result;
}

export default getFutureWeekDates;
